import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tCentro/theme/design";
import * as React from "react";
import { css } from "styled-components";

export interface CENAccountDetailsAddressInfoStyles {
    wrapper?: InjectableCss;
    companyNameText?: TypographyProps;
    address1Text?: TypographyProps;
    cityStatePostalCodeText?: TypographyProps;
    cityText?: TypographyProps;
    stateText?: TypographyProps;
    postalCodeText?: TypographyProps;
    phoneText?: TypographyProps;
}

export const cenAccountDetailsAddressInfoStyles: CENAccountDetailsAddressInfoStyles = {
    wrapper: {
        css: css`
            font-style: normal;
        `,
    },
    companyNameText: {
        css: css`
            color: ${getProp("theme.typography.p.color")};
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 12px;
        `,
    },
    address1Text: {
        css: css`
            color: ${getProp("theme.typography.p.color")};
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 12px;
        `,
    },
    cityStatePostalCodeText: {
        css: css`
            color: ${getProp("theme.typography.p.color")};
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 12px;
        `,
    },
    phoneText: {
        css: css`
            color: ${getProp("theme.typography.p.color")};
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 12px;
        `,
    },
};

interface OwnProps {
    companyName?: string;
    address1: string;
    city: string;
    state?: string;
    postalCode: string;
    phone?: string;
    extendedStyles?: CENAccountDetailsAddressInfoStyles;
}

type Props = OwnProps;

const StyledAddress = getStyledWrapper("address");

const CENAccountDetailsAddressInfo: React.FunctionComponent<Props> = function Address(props: Props) {
    const [styles] = React.useState(() => mergeToNew(cenAccountDetailsAddressInfoStyles, props.extendedStyles));
    return (
        <StyledAddress {...styles.wrapper} data-test-selector="addressInfoDisplay">
            {props.companyName && (
                <Typography as="p" {...styles.companyNameText} data-test-selector="addressInfoDisplay_companyName">
                    {props.companyName}
                </Typography>
            )}
            <Typography as="p" {...styles.address1Text} data-test-selector="addressInfoDisplay_address1">
                {props.address1}
            </Typography>
            <CityStatePostalCode city={props.city} state={props.state} postalCode={props.postalCode} styles={styles} />
            {props.phone && (
                <Typography as="p" {...styles.phoneText} data-test-selector="addressInfoDisplay_phoneNumber">
                    {props.phone}
                </Typography>
            )}
        </StyledAddress>
    );
};

interface CityStatePostalCodeProps {
    city: string;
    state?: string;
    postalCode: string;
    styles: CENAccountDetailsAddressInfoStyles;
}

const CityStatePostalCode = ({ city, state, postalCode, styles }: CityStatePostalCodeProps) => {
    return (
        <Typography as="p" {...styles.cityStatePostalCodeText}>
            <Typography {...styles.cityText} data-test-selector="addressInfoDisplay_city">
                {city}
            </Typography>
            {state && (
                <>
                    {", "}
                    <Typography {...styles.stateText} data-test-selector="addressInfoDisplay_state">
                        {state}
                    </Typography>
                </>
            )}
            {postalCode && (
                <>
                    {" "}
                    <Typography {...styles.postalCodeText} data-test-selector="addressInfoDisplay_postalCode">
                        {postalCode}
                    </Typography>
                </>
            )}
        </Typography>
    );
};

export default CENAccountDetailsAddressInfo;
